/**
 * Brandner Auction Product Page Fixes
 *
 * Fixes: Timer protection, color coding, scroll prevention, encoding
 * NOTE: Bid confirmation is handled by brandner-custom.php popup - NOT here!
 *
 * @version 2026-01-28 v11 - Fix: Bietschritte aus Backend-Ranges (window.brandnerBidRanges)
 */
(function($) {
    'use strict';

    var config = {
        antiSnipingWindowSeconds: 60,
        debug: (typeof brandnerProductRealtime !== 'undefined' && brandnerProductRealtime.debug) || false
    };

    // =================================================================
    // USER-EDITED FLAG (verhindert Auto-Ausfuell wenn Nutzer tippt)
    // Global fuer Debugging: window.userEditedBidInput
    // =================================================================
    window.userEditedBidInput = false;

    function log(msg, data) {
        if (config.debug) {
            console.log('[Brandner Fix] ' + msg, data || '');
        }
    }

    // =================================================================
    // TIMER PROTECTION
    // =================================================================

    var savedCountdownHtml = null;

    function backupCountdown() {
        var $countdown = $('#uwa_auction_countdown');
        if ($countdown.length > 0) {
            var html = $countdown.html();
            if (html && html.indexOf('refresh_msg') === -1 && html.indexOf('uwa_auction_product_countdown') !== -1) {
                savedCountdownHtml = html;
            }
        }
    }

    function restoreCountdownIfNeeded() {
        var $countdown = $('#uwa_auction_countdown');
        if ($countdown.length === 0) return;

        var currentHtml = $countdown.html();
        if (currentHtml && currentHtml.indexOf('refresh_msg') !== -1) {
            if (!isInAntiSnipingWindow() && savedCountdownHtml) {
                log('Restoring countdown');
                $countdown.html(savedCountdownHtml);
            }
        }
    }

    var originalHtml = $.fn.html;
    $.fn.html = function(value) {
        if (value !== undefined && this.is('#uwa_auction_countdown')) {
            if (typeof value === 'string' && value.indexOf('refresh_msg') !== -1) {
                if (!isInAntiSnipingWindow()) {
                    log('Blocked countdown replacement');
                    return this;
                }
            }
        }
        return originalHtml.apply(this, arguments);
    };

    function getRemainingSeconds() {
        var $countdown = $('.uwa_auction_product_countdown[data-time]');
        if ($countdown.length > 0) {
            var timeAttr = $countdown.attr('data-time');
            if (timeAttr) return parseInt(timeAttr, 10);
        }
        return null;
    }

    function isInAntiSnipingWindow() {
        var remaining = getRemainingSeconds();
        return remaining !== null && remaining <= config.antiSnipingWindowSeconds && remaining > 0;
    }

    // =================================================================
    // LIVE UPDATE BRANDNER-CURRENT-BID (PRICE ONLY)
    // =================================================================

    function getCurrentBidPrice() {
        var $amount = $('.woo-ua-auction-price .woocommerce-Price-amount, .woo-ua-auction-price .amount, .woo-ua-auction-price bdi');
        if ($amount.length > 0) {
            return $amount.first().text().trim();
        }
        var $brandnerBid = $('.brandner-current-bid .bid-value');
        if ($brandnerBid.length > 0) {
            return $brandnerBid.text().trim();
        }
        return '0,00 €';
    }

    function updateBrandnerCurrentBid() {
        var $currentBidElement = $('.brandner-current-bid .bid-value');
        if ($currentBidElement.length === 0) return;

        var $amount = $('.woo-ua-auction-price .woocommerce-Price-amount, .woo-ua-auction-price .amount, .woo-ua-auction-price bdi');
        if ($amount.length > 0) {
            var newBid = $amount.first().text().trim();
            var currentDisplayed = $currentBidElement.text().trim();

            if (newBid && newBid !== currentDisplayed) {
                $currentBidElement.text(newBid);
                $currentBidElement.addClass('bid-updated');
                setTimeout(function() {
                    $currentBidElement.removeClass('bid-updated');
                }, 1000);
                log('Updated current bid to: ' + newBid);

                // Also update status when bid changes
                updateBidStatusColor();
            }
        }
    }

    // =================================================================
    // COLOR CODING - IMPROVED DETECTION
    // =================================================================

    // Store the user's bid state
    var userHasBid = false;
    var userMaxBid = null;

    // Flag: Status wurde von checkPendingToast gesetzt und soll nicht ueberschrieben werden
    var stickyStatusSet = false;

    // Flag: Outbid wurde bereits geloggt (verhindert Console-Spam bei jedem Poll)
    var outbidAlreadyLogged = false;

    function updateBidStatusColor() {
        var $currentBidBox = $('.brandner-current-bid');
        if ($currentBidBox.length === 0) return;

        var status = 'none';

        // Check multiple sources for status

        // 1. Check uwa_winning/uwa_losing spans (most reliable)
        var $winning = $('.uwa_winning');
        var $losing = $('.uwa_losing');

        if ($winning.length > 0 && $winning.text().trim() !== '') {
            status = 'winning';
        } else if ($losing.length > 0 && $losing.text().trim() !== '') {
            status = 'outbid';
        }

        // 2. Check uwa_imgtext span (above image)
        var $imgText = $('span.uwa_imgtext');
        if ($imgText.length > 0) {
            var imgContent = $imgText.html();
            if (imgContent) {
                if (imgContent.indexOf('uwa_winning') !== -1) {
                    status = 'winning';
                } else if (imgContent.indexOf('uwa_losing') !== -1) {
                    status = 'outbid';
                }
            }
        }

        // 3. Check uwa_detailtext
        var $detailText = $('p.uwa_detailtext');
        if ($detailText.length > 0) {
            var detailHtml = $detailText.html();
            if (detailHtml) {
                if (detailHtml.indexOf('uwa_winning') !== -1) {
                    status = 'winning';
                } else if (detailHtml.indexOf('uwa_losing') !== -1) {
                    status = 'outbid';
                }
            }
        }

        // 4. Check max-bid paragraph
        var $maxBid = $('p.max-bid');
        if ($maxBid.length > 0 && $maxBid.text().trim() !== '') {
            userHasBid = true;
            // Extract max bid value
            var maxBidMatch = $maxBid.text().match(/[\d.,]+/);
            if (maxBidMatch) {
                userMaxBid = parseFloat(maxBidMatch[0].replace(',', '.'));
            }

            // If we have a max bid but status is still 'none', we're probably winning
            if (status === 'none') {
                status = 'winning';
            }
        }

        // 5. Compare max bid to current bid to detect outbid
        if (userHasBid && userMaxBid) {
            var currentBidText = getCurrentBidPrice();
            var currentBidMatch = currentBidText.match(/[\d.,]+/);
            if (currentBidMatch) {
                var currentBidValue = parseFloat(currentBidMatch[0].replace(',', '.'));
                if (currentBidValue > userMaxBid) {
                    status = 'outbid';
                    // Nur beim ersten Mal loggen (nicht bei jedem Poll)
                    if (!outbidAlreadyLogged) {
                        log('Detected outbid: current ' + currentBidValue + ' > max ' + userMaxBid);
                        outbidAlreadyLogged = true;
                    }
                } else {
                    // Status hat sich geaendert - Flag zuruecksetzen
                    outbidAlreadyLogged = false;
                }
            }
        }

        // 6. NEU: Check für "überboten" in Nachrichten (für sofortiges Überbieten durch Maximalgebot)
        var $messages = $('.woocommerce-message, .woocommerce-error, .woocommerce-info, .refresh_msg');
        $messages.each(function() {
            var msgText = $(this).text().toLowerCase();
            if (msgText.indexOf('überboten') !== -1 ||
                msgText.indexOf('outbid') !== -1 ||
                msgText.indexOf('höher') !== -1 ||
                msgText.indexOf('higher') !== -1 ||
                msgText.indexOf('verlier') !== -1 ||
                msgText.indexOf('losing') !== -1) {
                status = 'outbid';
                log('Detected outbid from message: ' + msgText.substring(0, 50));
            }
        });

        // 7. NEU: sessionStorage-basierte Erkennung für sofortiges Überbieten
        // Wenn User gerade ein Gebot abgegeben hat, aber nicht Höchstbietender ist
        var lastBidKey = 'brandner_last_bid_' + getProductIdFromPage();
        var lastBidData = sessionStorage.getItem(lastBidKey);
        if (lastBidData) {
            try {
                var bidInfo = JSON.parse(lastBidData);
                var currentBidText = getCurrentBidPrice();
                var currentBidMatch = currentBidText.match(/[\d.,]+/);
                if (currentBidMatch) {
                    var currentBidValue = parseFloat(currentBidMatch[0].replace('.', '').replace(',', '.'));
                    // Wenn aktuelles Gebot höher als unser letztes Gebot UND wir nicht gewinnen
                    if (currentBidValue > bidInfo.value && status !== 'winning') {
                        status = 'outbid';
                        log('Detected immediate outbid: bid was ' + bidInfo.value + ', current is ' + currentBidValue);
                    }
                }
                // Nach 10 Sekunden löschen (genug Zeit für Erkennung nach Reload)
                if (Date.now() - bidInfo.timestamp > 10000) {
                    sessionStorage.removeItem(lastBidKey);
                }
            } catch (e) {
                sessionStorage.removeItem(lastBidKey);
            }
        }

        // Wenn User gewinnt, sessionStorage löschen (kein falsches Outbid mehr)
        if (status === 'winning' && lastBidData) {
            sessionStorage.removeItem(lastBidKey);
            log('Cleared sessionStorage - user is winning');
        }

        // Apply status
        var prevStatus = $currentBidBox.data('status');
        if (prevStatus !== status) {
            $currentBidBox.removeClass('bid-status-none bid-status-winning bid-status-outbid');
            $currentBidBox.addClass('bid-status-' + status);
            $currentBidBox.data('status', status);
            log('Status changed: ' + (prevStatus || 'initial') + ' -> ' + status);
        }

        // brandner-bid-status wurde entfernt - Plugin-Anzeige (span.uwa_imgtext) wird verwendet
    }

    // Hilfsfunktion: Produkt-ID aus der Seite extrahieren
    function getProductIdFromPage() {
        var $input = $('input[name="product_id"], input[name="uwa_place_bid"]');
        if ($input.length > 0 && $input.val()) {
            return $input.val();
        }
        var $body = $('body');
        var bodyClass = $body.attr('class') || '';
        var match = bodyClass.match(/postid-(\d+)/);
        if (match) return match[1];
        return 'unknown';
    }

    // =================================================================
    // TOAST NOTIFICATIONS
    // Zeigt Benachrichtigungen nach Gebotabgabe
    // =================================================================

    function showBidToast(message, type) {
        type = type || 'info';
        var $toast = $('<div class="brandner-bid-toast toast-' + type + '">' + message + '</div>');

        // Inline-Styles pro Typ (cache-unabhängig, damit Toast sofort korrekt dargestellt wird)
        var styles = {
            error:   { bg: '#fef2f2', color: '#991b1b', border: '2px solid #fca5a5' },
            success: { bg: '#22c55e', color: 'white',   border: 'none' },
            warning: { bg: '#f97316', color: 'white',   border: 'none' },
            info:    { bg: '#3b82f6', color: 'white',   border: 'none' }
        };
        var s = styles[type] || styles.info;
        $toast.css({ 'background-color': s.bg, 'color': s.color, 'border': s.border });

        $('body').append($toast);

        // Animation: Einblenden
        setTimeout(function() {
            $toast.addClass('show');
        }, 10);

        // Nach 4 Sekunden ausblenden
        setTimeout(function() {
            $toast.removeClass('show');
            setTimeout(function() {
                $toast.remove();
            }, 300);
        }, 4000);

        log('Toast shown: ' + type + ' - ' + message);
    }

    // Globale Funktion fuer externe Nutzung
    window.showBidToast = showBidToast;

    // =================================================================
    // PREVENT SCROLL
    // =================================================================

    var originalAnimate = $.fn.animate;
    $.fn.animate = function(properties, duration, easing, complete) {
        if (this.is('html, body') && properties.scrollTop !== undefined && duration === 1500) {
            log('Blocked scroll');
            if (typeof complete === 'function') complete.call(this);
            else if (typeof easing === 'function') easing.call(this);
            return this;
        }
        return originalAnimate.call(this, properties, duration, easing, complete);
    };

    // =================================================================
    // ENCODING FIXES
    // =================================================================

    function fixEncodingIssues() {
        var replacements = {
            'ge├ñndert': 'geändert', 'k├Ânnen': 'können', 'f├╝r': 'für',
            '├ñ': 'ä', '├╝': 'ü', '├Â': 'ö', '├č': 'ß'
        };
        $('.refresh_msg, .woocommerce-message, .woocommerce-error').each(function() {
            var $el = $(this);
            var html = $el.html();
            if (!html) return;
            var changed = false;
            $.each(replacements, function(bad, good) {
                if (html.indexOf(bad) !== -1) {
                    html = html.split(bad).join(good);
                    changed = true;
                }
            });
            if (changed) $el.html(html);
        });
    }

    // =================================================================
    // PREVENT RELOAD (only outside anti-sniping window)
    // =================================================================

    var originalSetTimeout = window.setTimeout;
    window.setTimeout = function(callback, delay) {
        if (typeof callback === 'function' && delay === 5000) {
            var str = callback.toString();
            if (str.indexOf('reload') !== -1 && !isInAntiSnipingWindow()) {
                log('Blocked reload');
                return null;
            }
        }
        return originalSetTimeout.apply(window, arguments);
    };

    // =================================================================
    // BIETSCHRITT-BUTTONS LIVE AKTUALISIEREN
    // Verwendet die gleichen Werte wie PHP (vom Plugin berechnet)
    // =================================================================

    // Brandner Bietschritt aus Backend-Ranges (oder Default)
    function getBrandnerIncrement(price) {
        // Ranges aus PHP verwenden (wenn verfügbar)
        var ranges = window.brandnerBidRanges || [
            {start: 0, end: 15, inc_val: 1},
            {start: 15, end: 150, inc_val: 5},
            {start: 150, end: 500, inc_val: 10},
            {start: 500, end: 1000, inc_val: 20},
            {start: 1000, end: 5000, inc_val: 50},
            {start: 5000, end: 'onwards', inc_val: 100}
        ];

        for (var i = 0; i < ranges.length; i++) {
            var range = ranges[i];
            var start = parseFloat(range.start);
            var end = (range.end === 'onwards') ? Infinity : parseFloat(range.end);
            if (price >= start && price < end) {
                return parseFloat(range.inc_val);
            }
        }
        return 1; // Fallback
    }

    function updateBidButtons() {
        var $buttons = $('.brandner-bid-buttons .brandner-bid-btn');
        if ($buttons.length === 0) return;

        // Aktuelles Gebot aus der Seite lesen
        var currentBidText = getCurrentBidPrice();
        var currentBidMatch = currentBidText.match(/[\d.,]+/);
        if (!currentBidMatch) return;

        var currentBid = parseFloat(currentBidMatch[0].replace('.', '').replace(',', '.'));
        if (isNaN(currentBid) || currentBid <= 0) return;

        // Bietschritt dynamisch berechnen (statt statischem window.brandnerBidIncrement)
        var increment = getBrandnerIncrement(currentBid);

        // Nächstes Mindestgebot = aktuelles + Inkrement
        var nextBid = currentBid + increment;
        // Bei Startgebot: Noch kein Gebot vorhanden, Startpreis IST das Mindestgebot
        var $bidBox = $('.brandner-current-bid');
        if ($bidBox.hasClass('bid-status-startgebot')) {
            nextBid = currentBid;
        }

        log('Updating bid buttons: currentBid=' + currentBid + ', increment=' + increment + ', nextBid=' + nextBid);

        // Buttons aktualisieren mit dynamischem Brandner-Inkrement
        var currentValue = nextBid;
        $buttons.each(function(index) {
            var $btn = $(this);
            var bidValue = currentValue;
            var displayValue = bidValue.toLocaleString('de-DE', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + ' €';

            $btn.attr('data-value', bidValue);
            $btn.text(displayValue);

            // Nächsten Wert mit Brandner-Inkrement berechnen
            currentValue = currentValue + getBrandnerIncrement(currentValue);

            // Falls aktiv, auch den Select updaten
            if ($btn.hasClass('active')) {
                var $select = $('#uwa_bid_value_direct');
                var $customInput = $('#brandner-custom-bid');
                if ($select.length) {
                    // Option hinzufügen falls nicht vorhanden
                    if ($select.find('option[value="' + bidValue + '"]').length === 0) {
                        $select.append('<option value="' + bidValue + '">' + displayValue + '</option>');
                    }
                    $select.val(bidValue);
                }
                // NUR updaten wenn:
                // 1. Input NICHT fokussiert ist
                // 2. UND Nutzer noch nicht manuell getippt hat (userEditedBidInput Flag)
                if ($customInput.length && !$customInput.is(':focus') && !window.userEditedBidInput) {
                    $customInput.val(bidValue);
                }
            }
        });

        // Auch Placeholder im Input aktualisieren
        var $customInput = $('#brandner-custom-bid');
        if ($customInput.length) {
            $customInput.attr('placeholder', nextBid.toLocaleString('de-DE', {minimumFractionDigits: 0}) + ' oder höher');
        }

        // brandnerBidSteps für andere Funktionen aktualisieren (mit Brandner-Ranges)
        if (typeof window.brandnerBidSteps !== 'undefined') {
            window.brandnerBidSteps = [];
            var stepValue = nextBid;
            for (var i = 0; i < 20; i++) {
                window.brandnerBidSteps.push(stepValue);
                stepValue = stepValue + getBrandnerIncrement(stepValue);
            }
        }
    }

    // Speichere letztes bekanntes Gebot um unnötige Updates zu vermeiden
    var lastKnownBid = null;

    function checkAndUpdateBidButtons() {
        var currentBidText = getCurrentBidPrice();
        var currentBidMatch = currentBidText.match(/[\d.,]+/);
        if (!currentBidMatch) return;

        var currentBid = parseFloat(currentBidMatch[0].replace('.', '').replace(',', '.'));

        if (lastKnownBid !== currentBid) {
            lastKnownBid = currentBid;
            updateBidButtons();
        }
    }

    // =================================================================
    // HAPTIC FEEDBACK
    // =================================================================

    function triggerBidFeedback(type) {
        if (navigator.vibrate) {
            if (type === 'success') {
                navigator.vibrate([50, 30, 50]);
            } else if (type === 'error') {
                navigator.vibrate([100, 50, 100]);
            }
        }
    }

    // =================================================================
    // BID-SUBMIT LOADING STATE
    // =================================================================

    function setBidSubmitLoading($btn) {
        if (!$btn || !$btn.length) return;
        $btn.data('original-text', $btn.text());
        $btn.addClass('is-submitting').prop('disabled', true).text('...');
    }

    function clearBidSubmitLoading($btn) {
        if (!$btn || !$btn.length) return;
        var originalText = $btn.data('original-text');
        $btn.removeClass('is-submitting').prop('disabled', false);
        if (originalText) {
            $btn.text(originalText);
        }
    }

    // =================================================================
    // AJAX HANDLER
    // =================================================================

    $(document).ajaxComplete(function(event, xhr, settings) {
        if (!settings.data) return;

        var isBidAjax = settings.data.indexOf('uwa_ajax_placed_bid') !== -1;
        var isAuctionAjax = isBidAjax ||
            settings.data.indexOf('get_live_stutus_auction') !== -1;

        // Haptic feedback and loading state cleanup for bid submissions
        if (isBidAjax) {
            var bidSuccess = false;
            try {
                var responseData = typeof xhr.responseText === 'string' ? JSON.parse(xhr.responseText) : xhr.responseText;
                if (responseData && responseData.allstatus === 1) {
                    bidSuccess = true;
                }
            } catch (e) {
                // Parse error = treat as error
            }

            if (xhr.status === 200 && bidSuccess) {
                triggerBidFeedback('success');
            } else {
                triggerBidFeedback('error');
            }

            // Clear loading state on all bid-submit buttons
            $('.bid-submit-btn.is-submitting').each(function() {
                clearBidSubmitLoading($(this));
            });
        }

        if (isAuctionAjax) {
            setTimeout(function() {
                updateBrandnerCurrentBid();
                updateBidStatusColor();
                fixEncodingIssues();
                restoreCountdownIfNeeded();
                checkAndUpdateBidButtons(); // NEU: Buttons aktualisieren

                // NEU: Nach Gebot sofort Timer synchronisieren (Anti-Sniping sofort sichtbar)
                if (typeof window.BrandnerProductRealtime !== 'undefined' &&
                    typeof window.BrandnerProductRealtime.forceSync === 'function') {
                    window.BrandnerProductRealtime.forceSync();
                    log('Triggered timer force-sync after bid');
                }
            }, 300);
        }
    });

    // =================================================================
    // INITIALIZATION
    // =================================================================

    $(document).ready(function() {
        log('Initializing v9 (user-edit flag for auto-fill)');

        backupCountdown();
        updateBidStatusColor();
        fixEncodingIssues();

        // Check for pending toast messages (from previous bid submission)
        checkPendingToast();

        // Initial: Bid Buttons aktualisieren nach kurzer Verzögerung
        // (damit PHP-generierte Werte erst geladen sind)
        setTimeout(function() {
            checkAndUpdateBidButtons();
        }, 500);

        // User-Edit Detection: Flag setzen wenn Nutzer im Input tippt
        $('#brandner-custom-bid').on('input', function() {
            if ($(this).val().trim() !== '') {
                window.userEditedBidInput = true;
                log('User edited bid input - auto-fill disabled');
            }
        });

        // Bei Bietschritt-Button-Klick: Flag zuruecksetzen (Auto-Ausfuell wieder aktiv)
        $(document).on('click', '.brandner-bid-btn', function() {
            window.userEditedBidInput = false;
            log('Bid button clicked - auto-fill re-enabled');
        });

        // Bid-Submit Loading State: Button deaktivieren beim Klick
        $(document).on('click', '.bid-submit-btn', function() {
            var $btn = $(this);
            if (!$btn.hasClass('is-submitting')) {
                setBidSubmitLoading($btn);
            }
        });

        setInterval(function() {
            backupCountdown();
            // ENTFERNT: updateBrandnerCurrentBid() - wird von auction-product-realtime.js gemacht
            // ENTFERNT: updateBidStatusColor() - wird von auction-product-realtime.js gemacht
            // Diese Funktionen werden noch im ajaxComplete Handler aufgerufen (fuer sofortige Updates nach Gebot)
            restoreCountdownIfNeeded();
            checkAndUpdateBidButtons(); // Buttons bei jedem Poll prüfen
        }, 1500);

        log('Ready');
    });

    // =================================================================
    // CHECK PENDING TOAST (nach Reload)
    // =================================================================

    function checkPendingToast() {
        var productId = getProductIdFromPage();
        var toastKey = 'brandner_bid_toast_' + productId;

        try {
            var toastData = sessionStorage.getItem(toastKey);
            if (toastData) {
                var data = JSON.parse(toastData);

                // Nur anzeigen wenn nicht aelter als 10 Sekunden
                if (Date.now() - data.timestamp < 10000) {
                    // Status pruefen: Hoechstbietender oder ueberboten?
                    var status = 'none';
                    var $winning = $('.uwa_winning');
                    var $losing = $('.uwa_losing');

                    if ($winning.length > 0 && $winning.text().trim() !== '') {
                        status = 'winning';
                    } else if ($losing.length > 0 && $losing.text().trim() !== '') {
                        status = 'outbid';
                    }

                    // Wenn Status immer noch 'none' ist aber Toast gespeichert wurde,
                    // pruefe sessionStorage fuer letztes Gebot (direktes Gebot ohne Maximalgebot)
                    if (status === 'none') {
                        var bidKey = 'brandner_last_bid_' + productId;
                        var lastBidData = sessionStorage.getItem(bidKey);
                        if (lastBidData) {
                            // User hat gerade geboten aber ist nicht Hoechstbietender
                            status = 'outbid';
                            log('Status fallback: user bid but not winning -> outbid');
                        }
                    }

                    // Status-Box direkt aktualisieren (unter "Aktuelles Gebot")
                    var $statusBox = $('#brandner-bid-status');
                    if ($statusBox.length) {
                        $statusBox.removeClass('status-winning status-outbid');

                        if (status === 'winning') {
                            $statusBox.addClass('status-winning');
                            $statusBox.html('<span class="status-icon">&#10003;</span><span class="status-text">Ihr Gebot wurde angenommen! Sie sind Höchstbietender.</span>');
                            log('Status box updated: winning');
                            // Flag setzen damit updateBidStatusColor() den Status nicht ueberschreibt
                            stickyStatusSet = true;
                        } else if (status === 'outbid') {
                            $statusBox.addClass('status-outbid');
                            $statusBox.html('<span class="status-icon">&#9888;</span><span class="status-text">Ihr Gebot wurde angenommen, aber Sie wurden bereits überboten.</span>');
                            log('Status box updated: outbid');
                            // Flag setzen damit updateBidStatusColor() den Status nicht ueberschreibt
                            stickyStatusSet = true;
                        }
                    }
                }

                // Toast-Daten loeschen
                sessionStorage.removeItem(toastKey);
            }
        } catch (e) {
            log('Error checking pending toast: ' + e.message);
        }
    }

})(jQuery);
